import {
  GET_TRANSPORT_NOTE,
  GET_TRANSPORT_NOTE_SUCCESS,
  GET_TRANSPORT_NOTE_FAIL,
  GET_TRANSPORT_NOTE_BY_ID_SUCCESS,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
};

const TransportNote = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_TRANSPORT_NOTE:
      return {
        ...state,
        loading: true,
      };
    case GET_TRANSPORT_NOTE_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_TRANSPORT_NOTE_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_TRANSPORT_NOTE_FAIL:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default TransportNote;
